// deps
import React, { ReactElement, memo, useMemo, useCallback } from "react";
import PaymentOption from "../more-payment-options/components/payment-option";

// interfaces
import { ICreditCardEMIGroup } from "@payment-ui/interfaces/EMI";

// helpers
import { isEmpty } from "@swiggy-private/payment-core";
import {
    getPaymentGroupDisplayName,
    getPaymentGroupDisableMessage,
    getPaymentMethods,
    getPaymentGroupIconUrl,
    getPaymentGroupSubtext,
    getPaymentGroupIconPosition,
} from "@payment-ui/helpers/Payment";

// components
import PaymentGroupContainer from "../components/Container";
import PaymentGroupTitle from "../components/Title";

// test-ids
import { PAYMENT_GROUP_TEST_IDS } from "@swiggy-private/payment-test-ids";

// styles
import styles from "../PaymentGroup.v4.scss";

function CreditCardEMIGroup(props: ICreditCardEMIGroup): ReactElement | null {
    const { paymentData, hideGroupTitle, isFrictionPage } = props;

    const paymentMethods = useMemo(() => getPaymentMethods(props), [props]);
    const onEMIPaymentGroupClick = useCallback(() => {
        if (typeof props.onPaymentGroupClick === "function") {
            props.onPaymentGroupClick(paymentData);
        }
    }, [paymentData, props]);

    if (isEmpty(paymentMethods)) {
        return null;
    }
    // we need to render the EMI payment group option which internally has no second click navigation
    // we are reusing PaymentOption component to render the EMI payment group option
    return (
        <PaymentGroupContainer isFrictionPage={isFrictionPage}>
            {!hideGroupTitle && (
                <PaymentGroupTitle
                    title={getPaymentGroupDisplayName(paymentData)}
                    disableMessage={getPaymentGroupDisableMessage(paymentData)}
                    data-testid={PAYMENT_GROUP_TEST_IDS.TITLE.EMI}
                    capitalizeTitle={false}
                    groupIcon={getPaymentGroupIconUrl(props.paymentData)}
                    groupIconPosition={getPaymentGroupIconPosition(props.paymentData)}
                    groupSubtext={getPaymentGroupSubtext(props.paymentData)}
                />
            )}
            <div className={styles.paymentGroupContainer}>
                <PaymentOption
                    key={paymentData.groupName}
                    groupData={paymentData}
                    onClick={onEMIPaymentGroupClick}
                    isLastElement
                    useMethodForDisplayName
                />
            </div>
        </PaymentGroupContainer>
    );
}

export default memo(CreditCardEMIGroup);
